export default __webpack_public_path__ + "static/media/1_Intro.1e99c8fb.mp4";